export const randomString = () =>
  Math.random()
    .toString(36)
    .slice(2, 7)
